module.exports = __webpack_public_path__ + "img/songlv.4977427b.png";